<div class="courses-cards__item itineraryType" [ngClass]="{ checked: selected }">
  <div *ngIf="selectable" class="courses-cards__selectable">
    <gl-checkbox round [checked]="selected" (onChange)="selectCourse($event.detail.value)"></gl-checkbox>
  </div>
  <div class="courses-cards__image">
    <span class="courses-cards__label" *ngIf="!clientView && itinerary.unavailableCoursesforClients?.length > 0">{{
      'itineraries.info' | translate
    }}</span>
    <span *ngIf="itinerary.withdrawn" class="courses-cards__status-label courses-cards__withdrawn-label">
      <span class="glicon-retirado"></span>
      <span>{{ 'itineraries.withdrawnItinerary' | translate }}</span>
    </span>
    <div *ngIf="!itinerary.withdrawn">
      <span *ngIf="itinerary.publish.active" class="courses-cards__status-label courses-cards__publish-label">
        <span class="glicon-download-cloud"></span>
        <span>{{ 'itineraries.publishLabel' | translate }}</span>
      </span>
      <span *ngIf="!itinerary.publish.active" class="courses-cards__status-label courses-cards__draft-label">
        <span class="glicon-documents"></span>
        <span>{{ 'itineraries.draftLabel' | translate }}</span>
      </span>
    </div>
    <img onError="this.style.display = 'none';" [src]="imageUrl" />
  </div>
  <div class="courses-cards__data">
    <div class="courses-cards__block">
      <div class="duration">
        {{ itinerary.hours ? itinerary.hours + 'h' : itinerary.minutes ? '' : '0h' }}
        {{ itinerary.minutes ? itinerary.minutes + 'min' : '' }}
      </div>
      <div>
        {{
          'itineraries.numCoursesCard'
            | translate : { numCourses: itinerary.courses ? itinerary.courses.length : itinerary.modules.length }
        }}
      </div>
    </div>
    <div class="courses-cards__title">
      {{ itinerary.title || itinerary.name }}
    </div>
    <div class="courses-cards__originator">
      <span *ngIf="itinerary.clientId; else gamelearnItinerary">{{ itinerary.clientName }}</span>
      <ng-template #gamelearnItinerary>Gamelearn</ng-template>
    </div>
    <div *ngIf="defaultAccessMode" class="courses-cards__info">
      <span>{{ accessModeInfo }}</span>
    </div>
  </div>
  <div class="courses-cards__actions">
    <ng-container *ngIf="isItineraryRemovable">
      <div
        *lmsProfileGuard="'training.itineraries.delete'"
        class="courses-cards__actions--delete"
        (click)="modalDeleteItinerary.open()"
      >
        <span class="glicon-trash"></span>
      </div>
    </ng-container>
    <gl-button
      color-secondary
      text="{{ isItineraryEditable ? ('actions.seeOrEdit' | translate) : ('actions.showDetail' | translate) }}"
      (onClick)="showDetail()"
    >
    </gl-button>
    <gl-button
      class="courses-cards__publish-button"
      color-secondary
      *ngIf="isItineraryEditable && !itinerary.publish.active"
      text="{{ 'actions.publish' | translate }}"
      (onClick)="modalItineraryPublish.open()"
    >
    </gl-button>
    <div class="courses-cards__settings"></div>
  </div>
</div>

<lms-modal #modalDeleteItinerary size="small">
  <div class="gl-popup__title">{{ 'itineraries.notification.titleDelete' | translate }}</div>
  <div class="gl-popup__close" (click)="modalDeleteItinerary.close()">
    <span class="glicon-close"></span>
  </div>

  <div class="gl-popup__text" [innerHTML]="'itineraries.notification.textDelete' | translate : translateData"></div>

  <div class="gl-popup__text">{{ 'itineraries.notification.messageDelete' | translate }}</div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalDeleteItinerary.close()">
    </gl-button>
    <gl-button color-primary [text]="'actions.delete' | translate" (onClick)="deleteItinerary()"> </gl-button>
  </div>
</lms-modal>

<lms-itinerary-publish-modal
  #modalItineraryPublish
  [itinerary]="itinerary"
  (publish)="publishItinerary($event)"
></lms-itinerary-publish-modal>
